<template>
  <div class="subtitle">
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="reds"
        :disabled="disabledRed"
        @change="onChangeReds($event)"
      />
      <span class="red"></span> Faltosos
      <!-- <span v-b-tooltip.hover title="Faltosos para as vacinas polio ou penta" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span> -->
    </div>
    <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="greens"
        :disabled="disabledGreen"
        @change="onChangeGreens($event)"
      />
      <span class="green"></span> Em dias
      <!-- <span v-b-tooltip.hover title="Com vacinas polio e penta em dias" class="icon-tooltip">
                <i class="icofont-info-circle"></i>
            </span> -->
    </div>
    <!-- <div class="subtitle-item">
      <input
        type="checkbox"
        name=""
        v-model="blacks"
        :disabled="disabledBlack"
        @change="onChangeBlacks($event)"
      />
      <span class="black"></span>
      Transcrição
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'Subtitle',
  props: {
    items: {
      type: Array,
      default: () => {},
    },
    setRed: {
      type: Boolean,
      default: () => {},
    },
    disabledRed: {
      type: Boolean,
    },
    disabledGreen: {
      type: Boolean,
    },
    disabledBlack: {
      type: Boolean,
    },
  },
  data() {
    return {
      reds: false,
      greens: false,
      blacks: false,
    }
  },
  watch: {
    setRed: {
      handler(newValue, oldValue) {
        if (newValue === true) {
          this.$emit('resetarNome', this.setRed)
          this.greens = false
          this.blacks = false
          this.reds = true
        }
      },
      deep: true,
    },
  },
  methods: {
    onChangeReds(event) {
      this.greens = false
      this.blacks = false
      this.$emit('exibirVermelhos', event.target.checked)
    },
    onChangeGreens(event) {
      this.reds = false
      this.blacks = false
      this.$emit('exibirVerdes', event.target.checked)
    },
    onChangeBlacks(event) {
      this.greens = false
      this.reds = false
      this.$emit('exibirPretos', event.target.checked)
    },
  },
}
</script>

<style></style>
